// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"shadowboxlink_wrapper__nT515","linkOnRight":"shadowboxlink_linkOnRight___oWzZ","description":"shadowboxlink_description__WrcBt","link":"shadowboxlink_link__fjcdn"};